import { PlusIcon } from "lucide-react"
import { BoxShopEmptyIcon } from "@images/svgIcons/boxShop/boxShopEmptyIcon"
import { Text } from "@/components/ui/baseUi/text"
import { Button } from "@/components/ui/baseUi/button"
import { useBoxShopSidebar } from "@/modules/boxShop/hooks/useBoxShopSidebar"
import { word } from "@/modules/core/utils/i18n"
import { useBoxStaffPermission } from "@/modules/boxStaff/hooks/useBoxStaffPermissions"
import { BoxStaffPermissions } from "@/modules/boxStaff/gateway/boxStaffDto"
import { useRef } from "react"
import type { BoxShopItemFormRef } from "@/modules/boxShop/components/boxShopItemForm"

export function BoxShopEmptyView() {
  const { navigateToBoxShopItemForm } = useBoxShopSidebar()
  const canAddItem = useBoxStaffPermission(BoxStaffPermissions.ADD_ITEM)
  const boxShopItemFormRef = useRef<BoxShopItemFormRef>(null)
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <BoxShopEmptyIcon
        color="currentColor"
        className="h-35 w-40 transition-all duration-300 sm:h-[186px] sm:w-[200px]"
      />
      <Text fontStyle="HS">{word("boxShop.emptyView.title")}</Text>
      <Text fontStyle="BM">{word("boxShop.emptyView.subtitle")}</Text>
      {canAddItem && (
        <Button
          variant="primary"
          className="mt-8 w-fit"
          onClick={() => {
            void navigateToBoxShopItemForm({
              boxShopItemFormRef,
              args: { replaceAllComponents: true },
              item: undefined,
            })
          }}
        >
          <PlusIcon />
          {word("boxShop.item.text")}
        </Button>
      )}
    </div>
  )
}
